export default __webpack_public_path__ + "3d228ed0005d561c1479440ae415ab96.svg";